import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { CepValidator } from "src/app/shared/custom-validators/cep.validator";
import { AlertService, AlertType } from "src/app/shared/services/alert.service";
import { ViaCepService } from "src/app/shared/services/API/integration/via-cep.service";
import { PatientAccessUpdateDataService } from "src/app/shared/services/API/medical-record/patient-access-update-data.service";
import { HealthUnitService } from "src/app/shared/services/API/user/health-unit.service";
import { Masks, MaskService } from "src/app/shared/services/mask.service";
import { UpdatePatientAddressRequest } from "src/app/shared/services/requests/medical-record/update-patient-address-request";
import { BirthDateConfirmPatientModalComponent } from "../birth-date-confirm-patient-modal/birth-date-confirm-patient-modal.component";
import { PatientAccessUpdateDataStruct } from "src/app/shared/services/structs/medical-record/patient-access-update-data.struct";

@Component({
  selector: 'app-update-patient',
  templateUrl: './update-patient.component.html',
  styleUrls: ['./update-patient.component.css']
})
export class UpdatePatientComponent implements OnInit {
  constructor(private formBuilder: FormBuilder,
    private viaCepService: ViaCepService, private alertService: AlertService,
    private maskService: MaskService, private activatedRoute: ActivatedRoute,
    private patientAccessUpdateDataService: PatientAccessUpdateDataService,
    private healthUnitService: HealthUnitService, private dialog: MatDialog
  ) { }

  masks: Masks = this.maskService.getMasks();
  model!: FormGroup;
  isLoadingCep: boolean = true;
  isLoading: boolean = true;
  guid: string | null = null;
  healthUnitName: string | null = null;
  idPatient: number | null = null;
  idHealthUnit: number | null = null;
  patientAccessUpdateDataStruct: PatientAccessUpdateDataStruct = new PatientAccessUpdateDataStruct();

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.paramMap.get('guid')) {
      this.guid = this.activatedRoute.snapshot.paramMap.get('guid');
      if (this.guid != null)
        this.getRedirect();
    }

    this.model = this.formBuilder.group({
      street: ['', [Validators.required]],
      addressNumber: [''],
      addressComplement: [''],
      neighborhood: ['', [Validators.required]],
      zipCode: ['', [CepValidator(), Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      phone: ['', [Validators.required]]
    });
  }

  submit() {
    if (this.idPatient == null) {
      this.alertService.show('Erro', 'Paciente não identificado.', AlertType.error);
      return;
    }

    if (this.model.invalid) {
      this.alertService.show('Atenção', 'Por favor, verifique os campos preenchidos.', AlertType.warning);
      return;
    }
    this.isLoading = true;

    let request: UpdatePatientAddressRequest = new UpdatePatientAddressRequest;
    request.street = this.model.get('street')?.value;
    request.addressNumber = this.model.get('addressNumber')?.value;
    request.addressComplement = this.model.get('addressComplement')?.value;
    request.neighborhood = this.model.get('neighborhood')?.value;
    request.zipCode = this.model.get('zipCode')?.value;
    request.city = this.model.get('city')?.value;
    request.state = this.model.get('state')?.value;
    request.phone = this.model.get('phone')?.value;
    request.idHealthUnit = this.idHealthUnit;

    this.patientAccessUpdateDataService.putPatient(this.idPatient, request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.isLoading = false;
        this.alertService.show('Sucesso', 'Dados atualizados com sucesso.', AlertType.success);
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  formatCEP(cep: string): string {
    if (cep && cep.length === 8)
      return cep.substring(0, 5) + '-' + cep.substring(5);

    return cep;
  }

  private timeoutKeySearch: any = null;

  onKeySearchCEP(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13 && event.target.value.length > 5)
        $this.searchByCEP(event.target.value);
    }, 1000);
  }

  searchByCEP(cep: string) {
    this.isLoadingCep = true;
    this.viaCepService.getAddressByCep(cep).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoadingCep = false;
          return;
        }

        this.model?.get('zipCode')?.setValue(response?.cep);
        this.model?.get('street')?.setValue(response?.logradouro);
        this.model?.get('neighborhood')?.setValue(response?.bairro);
        this.model?.get('city')?.setValue(response?.localidade);
        this.model?.get('state')?.setValue(response?.uf);

        this.isLoadingCep = false;
      },
      error: (error) => {
        console.log(error);
        this.isLoadingCep = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getRedirect() {
    this.patientAccessUpdateDataService.getPatientByGuid(this.guid!).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.patientAccessUpdateDataStruct = response.patientAccessUpdateDataStruct;

        this.idPatient = response.patientAccessUpdateDataStruct?.idPatient ?? null;
        this.idHealthUnit = response.patientAccessUpdateDataStruct?.idHealthUnit ?? null;
        this.getHealthUnitName(response.patientAccessUpdateDataStruct?.idHealthUnit ?? null);
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getHealthUnitName(idHealthUnit: number) {
    if (idHealthUnit == null) {
      this.alertService.show('Erro', 'Unidade de saúde não identificada.', AlertType.error);
      this.isLoading = false;
      return;
    }

    this.healthUnitService.getHealthUnit(idHealthUnit).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.healthUnitName = response.healthUnitStruct?.healthUnitName ?? null;

        this.openBirthDateConfirmModal();
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  openBirthDateConfirmModal() {
    const dialogRef = this.dialog.open(BirthDateConfirmPatientModalComponent, {
      width: '400px',
      disableClose: true,
      data: {
        birthDate: this.patientAccessUpdateDataStruct?.birthDate
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result)
        this.alertService.show('Atenção', 'É necessário confirmar a data de nascimento.', AlertType.warning);
      else {
        this.model.get('street')?.setValue(this.patientAccessUpdateDataStruct?.street);
        this.model.get('addressNumber')?.setValue(this.patientAccessUpdateDataStruct?.houseNumber);
        this.model.get('addressComplement')?.setValue(this.patientAccessUpdateDataStruct?.apartmentNumber);
        this.model.get('neighborhood')?.setValue(this.patientAccessUpdateDataStruct?.neighborhood);
        this.model.get('zipCode')?.setValue(this.patientAccessUpdateDataStruct?.zipCode);
        this.model.get('city')?.setValue(this.patientAccessUpdateDataStruct?.city);
        this.model.get('state')?.setValue(this.patientAccessUpdateDataStruct?.state);
        this.model.get('phone')?.setValue(this.patientAccessUpdateDataStruct?.phone1 ?? this.patientAccessUpdateDataStruct?.phone2);

        this.isLoading = false;
      }
    });
  }
}